export default __webpack_public_path__ + "static/media/Coin M Stack Solid.519449d4.png";